import React, { useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";

/**
 * 
 * @param {props} id variable if need to be used
 * @param {props} schema string color scheme to be applied
 * @param {props} icon html element 
 * @param {props} count integer number which will be displayed
 * @param {props} title string title in card
 * @param {props} secondIcon html element
 * @param {props} desc string description text
 * @param {props} isSelected bool if true highlight card
 * @param {props} handler function when card is pressed
 * 
 * @returns card
 */
const QuickAccessCard = ({id, schema, icon, count, title, secondIcon, desc, isSelected, handler}) => {

    const [hover, setHover] = useState(false); // hover effect of card when mouse enters
    const [isDisabled, setIsDisabled] = useState(count === 0? true: false); // disabled effect if none of the type

    // if count changes, update disabled
    useEffect(() => {
        setIsDisabled(count > 0? false : true);
    }, [count])

    return (
        <Card 
            className={`h-100 disable-select ${hover && isDisabled === false? 'shadow-lg ':''} ${isDisabled? 'card-disabled ':''} ${isSelected? `bg-${schema}`: ''}`}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
            style={{borderRadius: "15px"}}
            onClick={() => !isDisabled? handler(id): null}
        >
            <Card.Body className="text-start">
                <Row>
                    <Col xs="9" className={`text-${isSelected? 'white': schema}`}>
                        {icon}
                    </Col>
                    {count?
                        <Col xs="3" className="text-end">
                            <div style={{background: "#EAEEF2", color:"#94A1AE", borderRadius:"25px", textAlign:"center", width: "auto", height: "auto", marginLeft: "auto", padding: "7px"}} >{count}</div>
                        </Col>
                    :null}
                </Row>
                <Row className="mt-4">
                    <h5 className={isSelected? 'text-white':'text-dark'}>{title}</h5>
                    <p className={`text-${isSelected? 'white': 'muted'}`}>
                        {secondIcon? <>secondIcon &nbsp;</>:null}
                        {desc}
                    </p>
                </Row>
            </Card.Body>
        </Card>
    )
}

export default QuickAccessCard;